module.exports = __webpack_public_path__ + "pc/img/banner1.14fe79db.jpg";